<template>
    <div class="my-gifts-item">
        <div class="my-gifts-info">
            <div v-if="gift.from_user" class="user-item">
                <router-link :to="'/profile/' + gift.from_user.id" :style="{
                    'background-image':
                        gift.from_user.avatar ?
                            'url(' + gift.from_user.avatar + ')' :
                            ''
                }" class="user-item-avatar" :class="{ 'no-avatar': !gift.from_user.avatar }"></router-link>
                <div class="user-item-info">
                    <router-link :to="'/profile/' + gift.from_user.id" class="user-item-title">{{ gift.from_user.name
                    }}</router-link>
                </div>
            </div>
            <div v-else class="user-item">
                <div class="user-item-avatar anonymous"></div>
                <div class="user-item-info">
                    <div class="user-item-title">
                        {{ $t("sendGift.anonymousGift") }}
                    </div>
                </div>
            </div>

            <div class="my-gifts-image-mobile">
                <img :src="gift.image" :alt="gift.name" class="my-gifts-img">
            </div>
            <div class="my-gifts-text" v-html="gift.message"></div>
            <span @click="$modal.show('gifts-list', { id: gift.from_user.id })" v-if="gift.from_user &&
                id == user.id
                " class="link-blue-underlined">
                {{ $t("sendGift.sendReturn") }}
            </span>
            <div v-if="gift.gift_id <= 9 &&
                id == user.id
                " class="my-gifts-vip">
                <div class="my-gifts-tip">
                    {{ $t("sendGift.thisGift") }} -
                    <span v-if="gift.gift_id <= 6">
                        {{ $t("sendGift.vipAccount") }},</span>
                    <span v-else>
                        {{ $t("sendGift.rouletteBets") }},</span>
                    {{ $t("sendGift.haveActivateUse") }}
                </div>
                <button v-if="loader" type="button" class="button button-loader"></button>
                <button v-else @click="activate(gift.id)" :disabled="gift.activated" class="button">
                    <span v-if="gift.activated">
                        {{ $t("sendGift.giftActivated") }}
                    </span>
                    <span v-else>{{ $t("sendGift.activateGift") }}</span>
                </button>
            </div>
        </div>
        <div class="my-gifts-image">
            <img :src="gift.image" :alt="gift.name" class="my-gifts-img">
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDateTime } from '@/mixins/formatDateTime';

export default {
    name: 'GiftItem',
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        gift: {
            type: Object,
            required: true
        },
        event: {
            type: [String, Number],
            required: false
        },
        i18n: Object,
    },
    mixins: [
        formatDateTime
    ],
    data() {
        return {
            loader: false
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            userIsEmpty: 'user/isEmpty',
            userGifts: 'gifts/fetchUserGifts',
            giftsIsEmpty: 'gifts/isEmpty'
        }),
    },
    created() {
        // console.log(this.gift);
    },
    methods: {
        activate(id) {
            this.loader = true;
            this.$store.dispatch('gifts/activate', id)
                .then(() => {
                    this.loader = false;
                    this.$modal.show('dialog', {
                        title: this.$t("albumEdit.success"),
                        text: this.$t("sendGift.giftSuccessfully"),
                        buttons: [
                            {
                                title: this.$t("albumEdit.ok")
                            }
                        ]
                    });
                    if (this.gift.gift_id >= 7 && this.gift.gift_id <= 9) {
                        this.$store.dispatch(
                            'init/addRouletteGift',
                            this.gift.gift_id - 6
                        );
                    }
                    this.gift.activated = true;
                    if (this.event) {
                        this.$store.dispatch(
                            'events/setGiftActivated',
                            this.event
                        );
                    }
                })
                .catch(() => {
                    this.loader = false;
                });
        }
    }
}
</script>
